




import {Component, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import {ONLINE_SERVICES, OnlineServiceConfig} from '@/site/constants';
import {Links} from '@/site/interfaces';

import Iframe from '../components/Iframe.vue';

@Component({
  components: {Iframe},
})
export default class OnlineService extends Vue {
  @Getter('links', {namespace: 'site'}) links!: Links | null;

  get config(): OnlineServiceConfig | undefined {
    return ONLINE_SERVICES.find((service) => service.slug === this.$route.params.service);
  }

  get title(): string {
    return this.config ? this.config.title : '';
  }

  get link(): string | undefined {
    return this.config && this.links ? this.links[this.config.linksField] : undefined;
  }

  mounted(): void {
    this.redirectIfUnavailable();
  }

  @Watch('$store.state.site.links')
  redirectIfUnavailable(): void {
    if (this.links && !this.link) {
      this.$router.replace({name: 'home', params: {slug: this.$route.params.slug}});
    }
  }
}
